import { apiFetch } from '../utils/api';

export interface DeployedModelCatalogEntry {
  name: string;
  group: string;
  kind: string;
  version: string;
}

export interface DeployedModelCatalog {
  backend_version: string;
  git_commit: string | null;
  git_branch: string | null;
  models: DeployedModelCatalogEntry[];
}

export async function fetchDeployedModelCatalog(): Promise<DeployedModelCatalog> {
  const response = await apiFetch('/api/model-catalog');
  if (!response.ok) {
    throw new Error(`Failed to load deployed model catalog (${response.status})`);
  }
  return response.json() as Promise<DeployedModelCatalog>;
}
